export default "__VITE_ASSET__55ZuJbml__"